/** Apply the CSV dialog's local calendar-date filter to visible OCI awards. */
import type { OciRecordSummary } from './ociDashboardModel'

function localDateKey(timestamp: string): string {
  const value = new Date(timestamp)
  if (Number.isNaN(value.getTime())) throw new Error(`Invalid OCI sync timestamp: ${timestamp}`)
  const year = value.getFullYear()
  const month = String(value.getMonth() + 1).padStart(2, '0')
  const day = String(value.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function filterOciRecordGroupsFromDate(
  groups: OciRecordSummary[],
  fromDate: string | null,
): OciRecordSummary[] {
  if (!fromDate) return groups
  if (!/^\d{4}-\d{2}-\d{2}$/.test(fromDate)) throw new Error(`Invalid OCI export date: ${fromDate}`)
  // cm-coding: Reviewers choose the same calendar day shown in the dashboard's
  // Synced column. Compare local date keys instead of UTC timestamps so an
  // award synced near midnight cannot appear on one day and export as another.
  return groups.filter(group => localDateKey(group.syncedAt) >= fromDate)
}
